import * as KeyCodes from "../keyCodes";

export const isEsc = (code) => code === KeyCodes.KEY_CODE_ESC
export const isEnter = (code) => code === KeyCodes.KEY_CODE_ENTER
export const isUp = (code) => code === KeyCodes.KEY_CODE_UP
export const isDown = (code) => code === KeyCodes.KEY_CODE_DOWN
export const isTab = (code) => code === KeyCodes.KEY_CODE_TAB
export const isSpace = (code) => code === KeyCodes.KEY_CODE_SPACE
export const isDel = (code) => code === KeyCodes.KEY_CODE_DEL
export const isPageUp = (code) => KeyCodes.KEY_CODE_PAGE_UP
export const isPageDown = (code) => KeyCodes.KEY_CODE_PAGE_DOWN

export const isChar = (code) => {
  return code >= 65 && code < 91
}

export const isNumber = code => {
  return code >= 48 && code < 58
}

export default {
    isEsc,
    isUp,
    isDown,
    isTab,
    isEnter,
    isSpace,
    isDel,
    isPageUp,
    isPageDown,
    isChar,
    isNumber
}


// WEBPACK FOOTER //
// ./web/js/keyHandlers/keyHelpers.js